export default {"src":"/_next/static/media/share_24.7f90126b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};